import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  trackId: '',
  otp: '',
  offerId: '',
  qrCode: '',
  activationCode: '',
  caseId: '',
  steps: [],
  qrData: null,
  tariffPrice: 0,
  deviceListModalOpen: false,
  pinModalOpen: false,
  notCustomerOpen: false,
  notSupportDeviceModalOpen: false,
  formData: null,
  swapPrefix: '055',
  swapNumber: '',
  customerPrefix: '',
  customerNumber: '',
  interestedNumberPrefix: '',
  activeSima: false,
  selectedPlan: '',
  disabled: false,
};

const order = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setTrackId: (state, action) => {
      state.trackId = action.payload;
    },
    setCaseId: (state, action) => {
      state.caseId = action.payload;
    },
    setSteps: (state, action) => {
      state.steps = action.payload;
    },
    setOtp: (state, action) => {
      state.otp = action.payload;
    },
    setOfferId: (state, action) => {
      state.offerId = action.payload;
    },
    setSwapPrefix: (state, action) => {
      state.swapPrefix = action.payload;
    },
    setInterestedNumberPrefix: (state, action) => {
      state.interestedNumberPrefix = action.payload;
    },
    setActiveSima: (state, action) => {
      state.activeSima = action.payload;
    },
    setSwapNumber: (state, action) => {
      state.swapNumber = action.payload;
    },
    setCustomerPrefix: (state, action) => {
      state.customerPrefix = action.payload;
    },
    setCustomerNumber: (state, action) => {
      state.customerNumber = action.payload;
    },
    setTariffPrice: (state, action) => {
      state.tariffPrice = action.payload;
    },
    setQrData: (state, action) => {
      state.qrData = action.payload;
    },
    openDeviceListModal: (state) => {
      state.deviceListModalOpen = true;
    },
    closeDeviceListModal: (state) => {
      state.deviceListModalOpen = false;
    },
    openPinModal: (state) => {
      state.pinModalOpen = true;
    },
    closePinModal: (state) => {
      state.pinModalOpen = false;
    },
    openNotCustomerModal: (state) => {
      state.notCustomerOpen = true;
    },
    closeNotCustomerModal: (state) => {
      state.notCustomerOpen = false;
    },
    openNotSupportDeviceModal: (state) => {
      state.notSupportDeviceModalOpen = true;
    },
    closeNotSupportDeviceModal: (state) => {
      state.notSupportDeviceModalOpen = false;
    },
    setFormData: (state, action) => {
      state.formData = action.payload;
    },
    setSelectedPlan: (state, action) => {
      state.selectedPlan = action.payload;
    },
    setDisabled: (state, action) => {
      state.disabled = action.payload;
    },
  },
});

export const { actions } = order;

export default order.reducer;
